/** @file Re-exports of Blockly.thrasos.* modules. */

/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

// Former goog.module ID: Blockly.thrasos

import {RenderInfo} from './info.js';
import {Renderer} from './renderer.js';

export {Renderer, RenderInfo};
